export default class ColorInterpolator {
  hexToRgb(hex) {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return [r, g, b];
  }

  rgbToHex(r, g, b) {
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  }

  interpolateColor(color1, color2, factor) {
    let result = color1.slice();
    for (let i = 0; i < 3; i++) {
      result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    }
    return result;
  }

  interpolateColors(colors) {
    let result = [...colors];
    let lastColorIndex = null;

    colors.forEach((color, index) => {
      if (color !== null) {
        if (lastColorIndex !== null) {
          // Perform interpolation between lastColorIndex and current index
          let startColor = this.hexToRgb(colors[lastColorIndex]);
          let endColor = this.hexToRgb(color);
          let stepCount = index - lastColorIndex;
          for (let step = 1; step < stepCount; step++) {
            let interpolatedColor = this.interpolateColor(
              startColor,
              endColor,
              step / stepCount,
            );
            result[lastColorIndex + step] = this.rgbToHex(...interpolatedColor);
          }
        }
        lastColorIndex = index;
      }
    });

    return result;
  }
}
